import React from "react";
const CustomArtRequestView = () => {
  return (
    <>
      <p>Test VIew</p>
    </>
  );
};

export default CustomArtRequestView;
